import React from "react";
import CustomHorizontalBarChart from "./CustomHorizontalBarChart";

const BusinessSectorSection = ({ currentData }) => {
  return (
    <div>
      <h3 className="text-xl my-2 p-0 text-[#3A3A3A] font-bold uppercase text-center text-balance">By Business Sector</h3>
      <CustomHorizontalBarChart
        data={currentData?.tradeBusinessData || []}
        otherBreakdown={currentData?.otherBusinessSectorData || []}
      />
    </div>
  );
};

export default BusinessSectorSection;